
import { useState,useEffect } from "react";
import "./App.css";
export default function BottomTabsTG({section}) {
  const [selected,setSelected] = useState(0);
  
  useEffect(() => {
    var h = window.location.hash;
    if(h && h == '#WHEEL'){
      setSelected(2);
    }
  },[]);

  return (
    <>
    <div className="bottomTabsContainer" style={{
        display:(section === 'EMORYANADVENTURE') ? 'none' : ''
      }}>
      <div className="bottomTabsOuterTg">
        <div className="btButton" onClick={() => {
            global.changeSection('HOMETG');
            setSelected(0);
        }} style={{
          color:(selected === 0) ? '#fff' : '#8892b0'
        }}>
        <i className="fa-solid fa-house"></i>
            <br/>
            HOME
        </div>
        <div className="btButton"  onClick={() => {
            global.changeSection('TEAMSTG');
            setSelected(1);
        }} style={{
          color:(selected === 1) ? '#fff' : '#8892b0'
        }}>
        <i className="fa-solid fa-people-group"></i>
            <br/>
            Teams
        </div>



        <div className="btButton" 
        
        onClick={() => {
          global.downloadApplication();
        }} >
             <img
                      alt=""
                      src={require("./assets/monoNew.png")}
                      style={{
                        height: 50,
                        marginTop:-25
                      }}
                    ></img>


<div style={{
  marginTop:0,
  color:'#fff'
}}>
MONETIZE
</div>

        </div>
       
       
       
        <div className="btButton"  onClick={() => {
            global.changeSection('WHEELOUTER');
            setSelected(2);
        }} style={{
          color:(selected === 2) ? '#fff' : '#8892b0'
        }}>
        <i className="fa-solid fa-gamepad"></i><br/>
            FORTUNE
        </div>
        <div className="btButton"   onClick={() => {
            global.changeSection('PROFILETG');
            setSelected(3);
        }} style={{
          color:(selected === 3) ? '#fff' : '#8892b0'
        }}>
        <i className="fa-regular fa-circle-user"></i><br/>
            Profile
        </div>

      </div>

      </div>
    </>
  );
}
